(function () {
  var sections = document.querySelectorAll("[data-compare-tabs]");
  if (!sections.length) return;

  function normalizeType(value) {
    return (value || "").toString().trim().toLowerCase();
  }

  function getFilterTypes(value) {
    var types = [];
    (value || "")
      .toString()
      .split(",")
      .forEach(function (entry) {
        var type = normalizeType(entry);
        if (type && types.indexOf(type) === -1) {
          types.push(type);
        }
      });
    return types;
  }

  function matchesFilterType(type, filterTypes) {
    if (!filterTypes.length) return true;
    return filterTypes.indexOf(normalizeType(type)) !== -1;
  }

  function getDefaultCompareUrl() {
    var sectionEl = document.querySelector(".compare-page-section");
    return sectionEl?.dataset.allProductsUrl || "/collections/all";
  }

  function updateCompareMoreUrl(url) {
    var targetUrl = url || getDefaultCompareUrl();
    var compareMoreLinks = document.querySelectorAll(
      ".compare-add-more__inner"
    );
    compareMoreLinks.forEach(function (link) {
      link.setAttribute("href", targetUrl);
    });
    var emptyStateLink = document.querySelector(".compare-no-product-url");
    if (emptyStateLink) {
      emptyStateLink.setAttribute("href", targetUrl);
    }
  }

  function getTabCompareUrl(tab) {
    return tab?.dataset.collectionUrl || getDefaultCompareUrl();
  }

  function applyFilter(filterType) {
    var filterTypes = getFilterTypes(filterType);
    var table = document.querySelector(".compare-table");
    if (!table) {
      return;
    }
    var basicRow = table.querySelector(".compare-row-basic");
    var showColumnByIndex = [];
    var allowedHandles = {};
    if (basicRow) {
      var basicCells = basicRow.querySelectorAll(".compare-value");
      basicCells.forEach(function (cell, index) {
        if (cell.classList.contains("compare-add-more")) {
          showColumnByIndex[index] = true;
          return;
        }
        var cellType = normalizeType(cell.dataset.productType);
        var cellHandle = cell.dataset.productHandle || "";
        if (!filterTypes.length || !cellType) {
          showColumnByIndex[index] = true;
          if (cellHandle) {
            allowedHandles[cellHandle] = true;
          }
          return;
        }
        var matches = matchesFilterType(cellType, filterTypes);
        showColumnByIndex[index] = matches;
        if (matches && cellHandle) {
          allowedHandles[cellHandle] = true;
        }
      });
    }

    var rowsForColumns = table.querySelectorAll(".compare-row");
    rowsForColumns.forEach(function (row) {
      var rowCells = row.querySelectorAll(".compare-value");
      rowCells.forEach(function (cell, index) {
        var showColumn =
          showColumnByIndex.length > 0 ? showColumnByIndex[index] : true;
        var handle = cell.dataset.productHandle || "";
        var isCompareMore = cell.classList.contains("compare-add-more");
        if (!isCompareMore && handle && Object.keys(allowedHandles).length > 0) {
          showColumn = !!allowedHandles[handle];
        }
        if (isCompareMore) {
          showColumn = true;
        }
        cell.classList.toggle("hidden", !showColumn);
        cell.toggleAttribute("hidden", !showColumn);
        cell.style.display = showColumn ? "" : "none";
      });
    });
    var rows = table.querySelectorAll("[data-compare-type]");
    rows.forEach(function (row) {
      var rowType = normalizeType(row.dataset.compareType);
      if (!filterTypes.length || !rowType) {
        row.classList.remove("hidden");
        row.removeAttribute("hidden");
        row.style.display = "";
        return;
      }
      var shouldHide = !matchesFilterType(rowType, filterTypes);
      row.classList.toggle("hidden", shouldHide);
      row.toggleAttribute("hidden", shouldHide);
      row.style.display = shouldHide ? "none" : "";
    });
  }

  sections.forEach(function (section) {
    var tabsRoot = section.querySelector("[data-tabs]");
    if (!tabsRoot) return;
    var carouselRoot = section.querySelector("[data-tabs-carousel]");
    var prevButton = carouselRoot
      ? carouselRoot.querySelector('[data-tabs-nav="prev"]')
      : null;
    var nextButton = carouselRoot
      ? carouselRoot.querySelector('[data-tabs-nav="next"]')
      : null;

    function updateNavState() {
      if (!prevButton && !nextButton) return;
      var maxScroll = tabsRoot.scrollWidth - tabsRoot.clientWidth;
      var atStart = tabsRoot.scrollLeft <= 1;
      var atEnd = tabsRoot.scrollLeft >= maxScroll - 1;
      if (prevButton) {
        prevButton.toggleAttribute("disabled", maxScroll <= 0 || atStart);
      }
      if (nextButton) {
        nextButton.toggleAttribute("disabled", maxScroll <= 0 || atEnd);
      }
    }

    function updateTabsOverflow() {
      var hasOverflow = tabsRoot.scrollWidth > tabsRoot.clientWidth + 1;
      tabsRoot.classList.toggle("tabs--overflowing", hasOverflow);
      if (carouselRoot) {
        carouselRoot.classList.toggle("tabs-carousel--overflowing", hasOverflow);
      }
      updateNavState();
    }

    function scrollTabsBy(direction) {
      if (!direction) return;
      var amount = tabsRoot.clientWidth * 0.8;
      tabsRoot.scrollBy({
        left: direction * amount,
        behavior: "smooth",
      });
    }

    function scrollTabIntoView(tab) {
      if (!tab) return;
      if (tabsRoot.scrollWidth <= tabsRoot.clientWidth + 1) return;
      if (typeof tab.scrollIntoView === "function") {
        tab.scrollIntoView({
          behavior: "smooth",
          inline: "start",
          block: "nearest",
        });
      }
    }

    function setActiveTab(tabId) {
      var tabs = tabsRoot.querySelectorAll(".tab");
      var activeTab = null;

      tabs.forEach(function (btn) {
        var isActive = btn.dataset.tab === tabId;
        btn.classList.toggle("is-active", isActive);
        btn.setAttribute("aria-selected", isActive ? "true" : "false");
        if (isActive) {
          activeTab = btn;
        }
      });

      scrollTabIntoView(activeTab);
    }

    tabsRoot.addEventListener("click", function (e) {
      var btn = e.target.closest(".tab");
      if (!btn) return;
      setActiveTab(btn.dataset.tab);
      applyFilter(btn.dataset.filterType);
      updateCompareMoreUrl(getTabCompareUrl(btn));
    });
    tabsRoot.addEventListener("scroll", updateNavState, { passive: true });

    if (prevButton) {
      prevButton.addEventListener("click", function () {
        scrollTabsBy(-1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", function () {
        scrollTabsBy(1);
      });
    }

    var firstTab = tabsRoot.querySelector(".tab");
    if (firstTab) {
      setActiveTab(firstTab.dataset.tab);
      applyFilter(firstTab.dataset.filterType);
      updateCompareMoreUrl(getTabCompareUrl(firstTab));
    }
    updateTabsOverflow();
    window.addEventListener("resize", updateTabsOverflow);

    document.addEventListener("compare:updated", function () {
      var activeTab =
        tabsRoot.querySelector(".tab.is-active") || firstTab || null;
      if (!activeTab) return;
      applyFilter(activeTab.dataset.filterType);
      updateCompareMoreUrl(getTabCompareUrl(activeTab));
      updateTabsOverflow();
    });
  });
})();
